export default __webpack_public_path__ + "static/media/avatarC6.a5de92e6.png";